import React from 'react';
import _ from 'lodash';

import PropTypes from 'prop-types';
import {
  Table as QuoteApprovalDashboardTable,
  Thead,
  Tbody,
  Tr,
  Th
} from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import Row from './Row';

const Table = ({ pageLayout, data, fetchOrders }) => {
  return (
    <QuoteApprovalDashboardTable>
      <Thead style={{ background: '#e2e2e2' }}>
        <Tr>
          {_.get(pageLayout, 'tableHeaders', []).map(header => (
            <Th
              key={_.get(header, 'sys.id', '')}
              style={{ textAlign: 'center' }}
            >
              {_.get(header, 'fields.title', '')}
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>
        {data &&
          data.map((order, index) => (
            <Row
              key={order.id}
              index={index}
              order={order}
              pageLayout={pageLayout}
              fetchOrders={fetchOrders}
            />
          ))}
      </Tbody>
    </QuoteApprovalDashboardTable>
  );
};

Table.propTypes = {
  pageLayout: PropTypes.objectOf(PropTypes.object).isRequired,
  data: PropTypes.objectOf(PropTypes.array).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Table;
